import axios from 'axios';
import store from 'store';

const state = {
  carrier: {},
  carriers: [],
  paginatedCarriers: {},
};

const getters = {
  getCarriersSearched: st => (page, q, sortBy, order) => {
    axios.get(`carriers?page=${page}&q=${q}&sort=${sortBy}&order=${order}`).then(res => {
      st.paginatedCarriers = res.data;
    });
  },
};

const mutations = {
  setCarrier: (st, payload) => {
    st.carrier = payload;
  },
  setCarriers: (st, payload) => {
    st.carriers = payload;
  },
  setPaginatedCarriers: (st, payload) => {
    st.paginatedCarriers = payload;
  },
};

const actions = {
  getCarriers: ({ commit }) => {
    return new Promise((resolve, reject) => {
      if (store.get('permissions') && store.get('permissions').indexOf('carriers.index') >= 0) {
        axios
          .get(`carriers?paginated=false`)
          .then(res => {
            commit('setCarriers', res.data);
            resolve();
          })
          .catch(() => {
            reject();
          });
      } else {
        resolve();
      }
    });
  },
  getPaginatedCarriers: ({ commit }) => {
    commit('setPaginatedCarriers', {});
    if (store.get('permissions').indexOf('carriers.index') >= 0) {
      axios.get(`carriers`).then(res => commit('setPaginatedCarriers', res.data));
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/carriers.js